/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import GlobeWorker from "App/workers/globe";
import IAddress from "App/utils/globe/chunk_lod/adress";
import PatchManager, {EPatchManagementStateEnum} from "App/utils/globe/chunk_lod/patch_manager";
import ProgressiveChunkLODNode from "App/utils/globe/chunk_lod/tree/progressive_chunk_lod_node";
import convertBase64ToUint8Array from "App/utils/globe/base_64_to_uint_8";

export default
class ModelManager extends PatchManager {
    constructor(aWorker: GlobeWorker, aBaseAddress: IAddress) {
        super(aWorker, aBaseAddress);
    }

    protected _downloadDecription() {
        let xhr = new XMLHttpRequest();

        xhr.onreadystatechange = () => {
            if (xhr.readyState !== XMLHttpRequest.DONE) {
                return xhr;
            }

            if ((xhr.status !== 200) && (xhr.status !== 0)) {
                // TODO Jarek notify about failing download of the desription
            }

            if (xhr.status === 200) {
                this._patchDescription = JSON.parse(xhr.responseText);

                let annotation = null;
                // pass through elements and look for Octree element. If such element is not found, then use annotation with index [0] because we have separatedly exported patch
                // TODO: piece of shit; I have to change the export so that we have for the octree elements a special annotation type
                for (let e = 0; e < this._patchDescription.Elements.length; e++) {
                    if (this._patchDescription.Elements[e].type === "Octree" || this._patchDescription.Elements[e].type === "Quadtree") {
                        annotation = this._patchDescription.Annotations[this._patchDescription.Elements[e].annotations[0]];
                        break;
                    }
                }

                this._annotation = JSON.parse(annotation.data);
                if (this._annotation.tops !== undefined) {
                    this._tops = new Float32Array(convertBase64ToUint8Array(this._annotation.tops));
                }

                if (this._annotation.heights !== undefined) {
                    // compatibility with old models
                    this._tops = new Float32Array(convertBase64ToUint8Array(this._annotation.heights));
                }

                if (this._annotation.bottoms !== undefined) {
                    this._bottoms = new Float32Array(convertBase64ToUint8Array(this._annotation.bottoms));
                }
                else {
                    this._bottoms = new Float32Array(this._tops.length);
                    for (let i = 0; i < this._tops.length; i++) {
                        this._bottoms[i] = this._tops[i] - 30;
                    }
                }

                this._usedNodes = new Uint8Array(convertBase64ToUint8Array(this._annotation.usedNodes));

                this._zeropointTranslationMatrix = this._patchDescription.ZeropointSettings.translationMat;
                this._state = EPatchManagementStateEnum.DESCRIPTION_READY;

                this._baseAddress.setTranslationOffset([this._zeropointTranslationMatrix[12], this._zeropointTranslationMatrix[14]]);
                this._root = new ProgressiveChunkLODNode(this, null, this.getBaseAddress());
            }
        };

        let url = this._baseAddress.getBaseURL() + "modelDescription.json";//this._baseAddress.origin + this._baseAddress.base + "modelDescription.json";
        xhr.open('GET', encodeURI(url), true);
        xhr.send(null);
    }
}
